export default {
  buttons: {
    start: 'Geplante Bestellung vorbereiten',
  },
};
